import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import { useMemo } from 'react';
import { Paper, Stack, styled, Text } from 'shell/components';

const getRandomFunFact = (studentSubmissions) => {
    if (!studentSubmissions?.length) return '';
    const latestStudentSubmission = studentSubmissions.sort((a, b) => a.created_on - b.created_on).slice(-1)[0];
    const arr = latestStudentSubmission?.ai?.ai_fun_facts;
    if (!arr?.length) return '';
    return arr[Math.floor(Math.random() * arr.length)];
};

const FunFactCard = () => {
    const { studentSubmissions } = useApp();
    const { device } = useViewport();

    const randomFunFact = useMemo(() => getRandomFunFact(studentSubmissions), [studentSubmissions]);

    return (
        <CustomPaper device={device}>
            <Stack spacing={3}>
                {!randomFunFact ? (
                    <>
                        <Text weight={'medium'}>Get a fun fact about your topic!</Text>
                        <Text>Submit your initial draft to discover interesting facts about your topic! 🔖</Text>
                    </>
                ) : (
                    <>
                        <Text weight={'medium'}>Did you know? 🤓</Text>
                        <Text>{randomFunFact}</Text>
                    </>
                )}
            </Stack>
        </CustomPaper>
    );
};

const CustomPaper = styled(Paper)(({ theme, device }) => {
    return {
        maxWidth: '500px',
        height: 'fit-content',
        padding: theme.spacing(3),
        ...(device !== 'mobile' && {
            alignSelf: 'end',
        }),
    };
});

export default FunFactCard;
